import { StorageService } from "./../../services/storage/storage.service";
import { ConfigService } from "./../../services/config/config.service";
import { BoletimService } from "./../../services/boletim/boletim.service";
import { AcaoBoletim } from "src/app/enums/acao-boletim.enum";
import { Component, OnInit } from "@angular/core";

import * as moment from "moment";
import { Router } from "@angular/router";

@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.page.html",
  styleUrls: ["./tabs.page.scss"]
})
export class TabsPage implements OnInit {
  constructor(
    private boletimService: BoletimService,
    private storageService: StorageService,
    private configService: ConfigService,
    private router: Router
  ) {}

  ngOnInit() {}

  public async carregarBoletins() {
    const verificarBoletim = await this.storageService.get("verificarBoletim");

    const dataAtual = moment();
    const dataVerificacaoBoletim = moment(verificarBoletim, "DD/MM/YYYY");

    dataVerificacaoBoletim.format("DD/MM/YYYY");
    if (dataAtual.isSameOrAfter(dataVerificacaoBoletim) || !verificarBoletim) {
      await this.boletimService.acaoBoletim(AcaoBoletim.Buscar, null, true);
    }
    if (window['cordova']) {
      await this.configService.checkTimeRangeBoletim(
        await this.boletimService.getBoletins()
      );
      this.boletimService.emitBoletins(await this.boletimService.getBoletins());
    }
  }
}
